import React from 'react';
import './DetailView.css';

const DetailView = () => {
  // 示例数据
  const unitDetails = {
    name: '福州市局',
    overallScore: 95.2,
    ranking: 1,
    performanceTrend: '+1.2%',
    indicators: [
      { name: '经营绩效', score: 92.1, trend: '+1.8%' },
      { name: '运营管控', score: 85.3, trend: '-0.5%' },
      { name: '卷烟营销', score: 89.7, trend: '+3.2%' },
      { name: '专卖监管', score: 91.2, trend: '+0.9%' },
      { name: '物流配送', score: 88.5, trend: '+1.1%' },
      { name: '创新发展', score: 78.9, trend: '+5.1%' }
    ],
    strengths: ['专卖监管', '经营绩效', '卷烟营销'],
    weaknesses: ['创新发展', '运营管控']
  };

  return (
    <div className="detail-view">
      <div className="detail-header">
        <h2>{unitDetails.name} 详细绩效分析</h2>
        <div className="detail-summary">
          <div className="summary-item">
            <span className="label">综合得分</span>
            <span className="value">{unitDetails.overallScore}</span>
          </div>
          <div className="summary-item">
            <span className="label">排名</span>
            <span className="value">{unitDetails.ranking}</span>
          </div>
          <div className="summary-item">
            <span className="label">趋势</span>
            <span className="value">{unitDetails.performanceTrend}</span>
          </div>
        </div>
      </div>
      
      <div className="detail-content">
        <div className="indicators-section">
          <h3>各项指标详情</h3>
          <div className="indicators-grid">
            {unitDetails.indicators.map((indicator, index) => (
              <div key={index} className="indicator-item">
                <span className="indicator-name">{indicator.name}</span>
                <div className="indicator-details">
                  <span className="indicator-score">{indicator.score}</span>
                  <span className={`indicator-trend ${indicator.trend.startsWith('+') ? 'positive' : 'negative'}`}>
                    {indicator.trend}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="analysis-section">
          <div className="strengths-section">
            <h3>优势领域</h3>
            <ul>
              {unitDetails.strengths.map((strength, index) => (
                <li key={index}>{strength}</li>
              ))}
            </ul>
          </div>
          
          <div className="weaknesses-section">
            <h3>需改进领域</h3>
            <ul>
              {unitDetails.weaknesses.map((weakness, index) => (
                <li key={index}>{weakness}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailView;